import { useNavigate } from 'react-router-dom';

export function SettingsTrustSection() {
  const navigate = useNavigate();

  return (
    <div className="grid gap-3 md:grid-cols-2">
      <button
        type="button"
        data-testid="trust-audit-log-link"
        onClick={() => navigate('/you/settings/audit')}
        className="rounded-lg border border-neutral-200 bg-neutral-50 p-3 text-left transition-colors hover:bg-neutral-100"
      >
        <span className="block text-sm font-semibold text-neutral-900">AuditLog</span>
        <span className="mt-1 block text-xs text-neutral-500">
          Review signed current-device trust events.
        </span>
      </button>
      <button
        type="button"
        data-testid="trust-recovery-status"
        onClick={() => navigate('/recover')}
        className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-left"
      >
        <span className="block text-sm font-semibold text-amber-900">Recovery</span>
        <span className="mt-1 block text-xs text-amber-800">
          Provider proof pending; no mock recovery success is exposed.
        </span>
      </button>
    </div>
  );
}
